import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'trpx-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  errorModalRef?: BsModalRef;

  @Input() headData: any;
  @Input() subHeadData: any;
  @Input() autoClose: boolean = false;
  @Input() autoCloseTime: number = 3000000;
  @Input() modalColor: any;

  // autoCloseTime: number = 5000; // Example: 5 seconds (5000ms)
  remainingTime: number = this.autoCloseTime / 1000; // Convert to seconds
  loaderWidth: any;
  constructor(public modalRef: BsModalRef) {
    console.log('modalColor', this.modalColor);
  }

  ngOnInit(): void {
    // if (this.autoClose) {
    //   setTimeout(() => {
    //     this.close();
    //   }, this.autoCloseTime);
    // }
    if (this.autoClose) {
      const interval = 100; // Update every 100ms
      const totalSteps = this.autoCloseTime / interval;
      let step = totalSteps;

      const countdown = setInterval(() => {
        this.remainingTime = Math.ceil((step * interval) / 1000); // Convert to seconds
        this.loaderWidth = (step / totalSteps) * 100; // Gradually reduce width
        step--;

        if (step <= 0) {
          clearInterval(countdown);
          this.close();
        }
      }, interval);
    }
  }

  getModalClass(): string {
    switch (this.modalColor) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return ''; // No class if modalColor is not recognized
    }
  }

  close() {
    this.modalRef.hide();
  }
}
